/* global axios */
import ApiClient from './ApiClient';

class MeetingsAPI extends ApiClient {
  constructor() {
    super('meetings', { accountScoped: true });
  }

  registerRoom({ roomId, ttl = 2592000, info = '' }) {
    return axios.post(`${this.url}/register_room`, {
      room_id: roomId,
      ttl,
      info,
    });
  }
}

export default new MeetingsAPI();
